import axios from 'axios'
import { Api } from '@/helpers/api'

enum StorageKey { AccessToken = 'accessToken', AuthUser = 'authUser', InstallationId = 'installationId' }

export class AuthUtil {
  static async authenticate (username: string, password: string) {
    try {
      const response = await axios.post(`${Api.Hub}/security/anon/accesstoken`, { username, password })

      if (response.data && response.data.accessToken) {
        localStorage.setItem(StorageKey.AccessToken, response.data.accessToken)
      }
    } catch (e) {
      throw new Error(e.response.data)
    }
  }

  static get authenticatedHeaders (): { [k in Api]: { [k: string]: string | null } } | null {
    if (this.isAuthenticated === false) {
      return null
    }

    return {
      [Api.Hub]: {
        'x-auth-token': this.accessToken
      },
      [Api.DialPlanService]: {
        Authorization: `Token ${this.accessToken}`
      }
    }
  }

  static async logout () {
    try {
      const headers = AuthUtil.authenticatedHeaders

      if (headers) {
        await axios.delete(`${Api.Hub}/user/logout`, {
          headers: headers[Api.Hub]
        })
      }

      AuthUtil.invalidateSession()
    } catch (e) {
      throw new Error(e.response)
    }
  }

  static invalidateSession () {
    localStorage.removeItem(StorageKey.AccessToken)
  }

  static get isAuthenticated (): boolean {
    return this.accessToken !== null
  }

  static get accessToken (): string | null {
    return localStorage.getItem(StorageKey.AccessToken)
  }

  static get installationId (): string | null {
    return localStorage.getItem(StorageKey.InstallationId)
  }

  static setInstallationId (id: string | null) {
    if (id) {
      localStorage.setItem(StorageKey.InstallationId, id)
    }
  }
}
